import styled from 'styled-components';

export const Wrapper = styled.label<any>`
  display: block;
  background-color: #ffffff;
  border-radius: 8px;
  height: fit-content;
  display: flex;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #000000e0;
  transition: all 0.3s;
  border: 2px solid transparent;
  padding-right: 16px;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 9;

  &.selected {
    border-color: #2b45d4 !important;
  }

  input[type='radio'] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0 19px 0 16px;
    font: inherit;
    color: currentColor;
    border: 2px solid #0000008f;
    padding: 2px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    cursor: pointer;
    box-sizing: border-box;
  }

  input[type='radio']:checked {
    border-color: #ff0073;
  }

  input[type='radio']::before {
    display: flex;
    align-items: center;
    justify-content: center;
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #ff0073;
  }

  input[type='radio']:checked::before {
    transform: scale(0.8);
  }
`;
